import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { t } from '../../i18n/translate.js';
import SelectionField from '../../components/SelectionField/SelectionField.js';
import SidePanelInfoBox from '../../components/SidePanelInfoBox/SidePanelInfoBox.js';
import styles from './PetType.module.scss.js';

var PetType = function PetType(_ref) {
  var petTypes = _ref.petTypes,
    onChange = _ref.onChange,
    currentPetType = _ref.currentPetType;
  var _useState = useState(currentPetType),
    _useState2 = _slicedToArray(_useState, 2),
    selectedPetType = _useState2[0],
    setSelectedPetType = _useState2[1];
  var updatePetType = function updatePetType(value) {
    setSelectedPetType(value);
    onChange(value);
  };
  useEffect(function () {
    setSelectedPetType(currentPetType);
  }, [currentPetType]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SidePanelInfoBox, {
    icon: "icon-security-dog",
    title: t('MPLIB_SELECT_PET_TYPE'),
    text: t('MPLIB_SELECT_PET_TYPE_TEXT'),
    className: styles.selectPetTypeInfo
  }), /*#__PURE__*/React.createElement(SidePanelInfoBox, {
    icon: "icon-alert",
    title: t('MPLIB_SELECT_PET_TYPE_NOTE_TITLE'),
    text: t('MPLIB_SELECT_PET_TYPE_NOTE_TEXT'),
    className: styles.selectPetTypeNote
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.selectPetType
  }, /*#__PURE__*/React.createElement(SelectionField, {
    name: "typeOfPetSelection",
    dataTestId: "type-of-pet-selector",
    defaultValue: selectedPetType || 'NONE',
    onChange: updatePetType
  }, petTypes.map(function (val) {
    return /*#__PURE__*/React.createElement("p", {
      key: val,
      value: val,
      id: "select-pet-type-".concat(val)
    }, t("MPLIB_SELECT_PET_TYPE_".concat(val)));
  }))));
};
PetType.propTypes = {
  petTypes: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
  currentPetType: PropTypes.string
};
PetType.defaultProps = {
  currentPetType: 'NONE',
  petTypes: []
};

export { PetType as default };
